import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=74b37487"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b37487')) {
      api.createRecord('74b37487', component.options)
    } else {
      api.reload('74b37487', component.options)
    }
    module.hot.accept("./Filtros.vue?vue&type=template&id=74b37487", function () {
      api.rerender('74b37487', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otros-documentos/Filtros.vue"
export default component.exports